/* WHOVIX sitewide enhancer: reveal tagging, quick add, accordion, sticky ATC. */

(function () {
  'use strict';

  if (window.__whovixEnhance) return;
  window.__whovixEnhance = true;

  var REVEAL_MAP = [
    ['.whovix-intro__eyebrow', 'up'],
    ['.whovix-intro__heading', 'up'],
    ['.whovix-intro__body', 'up'],
    ['.whovix-intro__link', 'up'],
    ['.whovix-editorial__media', 'clip'],
    ['.whovix-editorial__text', 'up'],
    ['.whovix-featured__heading', 'up'],
    ['.whovix-product-card', 'up'],
    ['.collection-hero__inner', 'up'],
    ['.main-page-title', 'up'],
    ['.product__media-wrapper', 'fade'],
    ['.product__info-wrapper', 'up'],
    ['.article-card', 'up'],
    ['.collection .card-wrapper', 'up'],
    ['.collection-list .card-wrapper', 'up']
  ];

  var STAGGER_PARENTS = [
    ['.whovix-featured__grid', 90],
    ['.whovix-editorial', 120],
    ['.product-grid', 70],
    ['.collection-list', 90],
    ['.blog-articles', 90]
  ];

  function tag(root) {
    STAGGER_PARENTS.forEach(function (pair) {
      Array.prototype.forEach.call(root.querySelectorAll(pair[0]), function (el) {
        if (!el.hasAttribute('data-wx-stagger')) {
          el.setAttribute('data-wx-stagger', pair[1]);
        }
      });
    });

    REVEAL_MAP.forEach(function (pair) {
      Array.prototype.forEach.call(root.querySelectorAll(pair[0]), function (el) {
        if (!el.hasAttribute('data-wx-reveal')) {
          el.setAttribute('data-wx-reveal', pair[1]);
        }
      });
    });

    if (typeof window.whovixMotionInit === 'function') {
      window.whovixMotionInit(root);
    }
  }

  /* Quick add to cart */

  function refreshCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var bubble = document.getElementById('cart-icon-bubble');
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');

    fetch(root + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html || !bubble) return;
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#cart-icon-bubble');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});

    try {
      if (drawer && typeof drawer.open === 'function') drawer.open();
      else if (notification && typeof notification.open === 'function') notification.open();
    } catch (e) {}
  }

  function quickAdd(button) {
    var id = button.getAttribute('data-wx-variant');
    if (!id) return;

    var original = button.getAttribute('data-wx-label') || button.textContent.trim();
    button.setAttribute('data-wx-label', original);
    button.disabled = true;
    button.textContent = button.getAttribute('data-wx-adding') || 'Adding...';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        button.disabled = false;
        button.classList.add('is-added');
        button.textContent = button.getAttribute('data-wx-added') || 'Added';
        refreshCart();
        setTimeout(function () {
          button.classList.remove('is-added');
          button.textContent = original;
        }, 2200);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = button.getAttribute('data-wx-error') || 'Try again';
        setTimeout(function () { button.textContent = original; }, 2200);
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.wx-quick-add');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    quickAdd(button);
  });

  /* Accordion */

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-wx-accordion-trigger]');
    if (!trigger) return;

    var item = trigger.closest('[data-wx-accordion-item]');
    var panel = item && item.querySelector('[data-wx-accordion-panel]');
    if (!panel) return;

    var open = item.classList.toggle('is-open');
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '';

    var group = item.closest('[data-wx-accordion-single]');
    if (open && group) {
      Array.prototype.forEach.call(
        group.querySelectorAll('[data-wx-accordion-item].is-open'),
        function (other) {
          if (other === item) return;
          other.classList.remove('is-open');
          var otherPanel = other.querySelector('[data-wx-accordion-panel]');
          var otherTrigger = other.querySelector('[data-wx-accordion-trigger]');
          if (otherPanel) otherPanel.style.maxHeight = '';
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        }
      );
    }
  });

  /* Sticky add-to-cart on mobile product pages */

  function stickyAtc() {
    if (document.querySelector('.wx-sticky-atc')) return;

    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form) return;

    var submit = form.querySelector('[type="submit"]');
    var titleEl = document.querySelector('.product__title h1, .product__title h2, .whovix-product__title');
    var priceEl = document.querySelector('.product__info-wrapper .price .price-item, .whovix-product__price');
    if (!submit || !titleEl) return;

    var bar = document.createElement('div');
    bar.className = 'wx-sticky-atc';
    bar.innerHTML =
      '<div class="wx-sticky-atc__info">' +
      '<span class="wx-sticky-atc__name"></span>' +
      '<span class="wx-sticky-atc__price"></span>' +
      '</div>' +
      '<button type="button" class="wx-sticky-atc__btn"></button>';

    bar.querySelector('.wx-sticky-atc__name').textContent = titleEl.textContent.trim();
    if (priceEl) bar.querySelector('.wx-sticky-atc__price').textContent = priceEl.textContent.trim();
    bar.querySelector('.wx-sticky-atc__btn').textContent = submit.textContent.trim() || 'Add to cart';

    bar.querySelector('.wx-sticky-atc__btn').addEventListener('click', function () {
      submit.click();
    });

    document.body.appendChild(bar);

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    io.observe(submit);
  }

  function init(root) {
    var scope = root || document;
    tag(scope);
    stickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });

  window.whovixEnhanceInit = init;
})();
